import tinycolor from 'tinycolor2'

/**
 * TANAAKK universal-guideline 準拠カラーシステム
 * https://github.com/tanaakk/universal-guideline (tanaakk-ui-ux.mdc)
 * 汎用モダン・ライトクリーン
 */
export const Colors = {
  primary: '#3B82F6', // 信頼感のある Blue (universal-guideline)
  secondary: '#19BCFE',
  black: '#111827', // Text メイン (Almost Black)
  link_color: '#3B82F6',
  // button

  // color for background (universal-guideline: Primary #3B82F6 for accent)
  bg_primary: '#3B82F6',
  bg_secondary: '#ffa2c0',
  bg_success: '#46bcaa',
  bg_info: '#4d69fa',
  bg_warning: '#ffcf52',
  bg_danger: '#f35421',
  bg_light: '#e7eef8',
  bg_dark: '#1f2128',
  bg_blue_white: 'linear-gradient(180deg, rgba(250, 251, 253, 0.546028) 0.05%, #FEFEFF 84.64%, #FFFFFF 100%)',
  bg_block: '#FAF9F7',
  bg_block_header: '#E5E3E3',
  bg_error: '#fff2f0',
  bg_error_light: '#f2dede',
  bg_hight_light: '#19191f',
  bg_dark_transparent: '#090a0c80',
  bg_light_transparent: '#ffffff80',
  bg_primary_dark: '#1d1f27',
  bg_primary_light: '#F9FAFB', // universal-guideline Background
  bg_auth: '#F9FAFB',
  // color for border
  bd_error: '#ffccc7',
  bd_error_light: '#ebccd1',
  border: '#E5E7EB', // universal-guideline Border

  // color for text (universal-guideline)
  text_primary: '#111827', // Text メイン
  text_secondary: '#6B7280', // Text サブ (Muted Gray)
  text_hight_light: '#e7eef8',
  text_error: '#a94442',

  // social btn color
  fb_color: '#09519B',
  google_color: '#F14436',

  blue: '#1890ff',
  blueHight: '#106BB4',
  blueLow: '#3498db',
  blueDark: '#34495e',
  green: '#07CF84',
  red: '#f5222d',
  orange: '#e74c3c',
  orangeLow: '#F0AD4E',
  yellow: '#F5CF50',
  yellow_light: '#F3E926',
  error: '#D85B46',
  error_ant: '#ff4d4f',
  white: '#FFFFFF',
  grey: '#bdc3c7',
  greyHight: '#777777',
  greyLow: '#D6DBDF',
  greyMid: '#ECF0F1',
  grey_light: '#e4e7ea',
  grey_white: '#FAFAFA',
  greyHigh: '#777',
  transparent: 'transparent',
  purple: '#d3dafe'
}

export const alpha = (color, value) => tinycolor(color).setAlpha(value).toRgbString()

export default Colors
